import React from "react";
import { useNavigate } from "react-router-dom";
import { useBilling } from "@/contexts/BillingContext";
import { Clock, Sparkles, AlertTriangle, Crown } from "lucide-react";

export const TrialCountdown = () => {
    const { billing } = useBilling();
    const navigate = useNavigate();

    if (!billing) return null;

    const isTrial = billing.is_trial && billing.subscription_active;
    const expired = billing.trial_used && !billing.subscription_active;
    const days = billing.days_remaining || 0;
    const isUrgent = isTrial && days <= 3;

    if (!isTrial && !expired) return null;

    if (expired) {
        return (
            <button
                onClick={() => navigate("/billing")}
                data-testid="trial-expired-card"
                className="w-full text-left bg-red-900/30 border border-red-700/50 rounded-md p-3 hover:bg-red-900/40 transition-colors animate-pulse"
            >
                <div className="flex items-center gap-2 mb-1">
                    <AlertTriangle className="w-4 h-4 text-red-300" />
                    <div className="text-[10px] uppercase tracking-wider text-red-300 font-bold">Trial scaduto</div>
                </div>
                <div className="text-xs text-warm">Riattiva ora →</div>
            </button>
        );
    }

    return (
        <button
            onClick={() => navigate("/billing")}
            data-testid="trial-countdown-card"
            className={`w-full text-left rounded-md p-3 border transition-all ${
                isUrgent
                    ? "bg-red-900/25 border-red-700/50 animate-pulse"
                    : "bg-brand-soft border-brand/40 hover:bg-brand/15"
            }`}
        >
            <div className="flex items-center gap-2 mb-1">
                {isUrgent ? <AlertTriangle className="w-4 h-4 text-red-300" /> : <Clock className="w-4 h-4 text-brand" />}
                <div className={`text-[10px] uppercase tracking-wider font-bold ${isUrgent ? "text-red-300" : "text-brand"}`}>
                    Trial gratuito
                </div>
            </div>
            <div className={`font-display text-2xl font-bold leading-none ${isUrgent ? "text-red-300" : "text-warm"}`}>
                {Math.ceil(days)}<span className="text-xs text-elegant ml-1">giorni</span>
            </div>
            <div className="mt-2 flex items-center gap-1 text-[10px] uppercase tracking-wider">
                <Sparkles className="w-3 h-3 text-brand" />
                <span className="text-brand font-bold">-20% se rinnovi ora</span>
            </div>
            <div className="mt-1 text-[10px] text-elegant flex items-center gap-1">
                <Crown className="w-3 h-3" /> Attiva Premium →
            </div>
        </button>
    );
};

export default TrialCountdown;
